import { lighten } from 'polished';

const minAgeWithColor = 13;
const maxAgeWithColor = 18;

const baseMaleColors = ['#BBDBF7', '#A5CFF5', '#8FC3F2', '#78B8EF', '#62ACED', '#1E88E5'];
const baseFemaleColors = ['#F8BBD0', '#F6A5C1', '#F48FB1', '#F06292', '#F06292', '#E91E63'];
const baseNogenderColors = Array.from({ length: 6 }).map((_, idx) =>
    lighten((idx - 1) / 100)('#807f7f'),
);

const agesRangeList = Array.from({ length: 50 }, (_, index) => index + 1);

const generateColorsMapByAgesRange = (rangeList: number[], colors: string[]) =>
    rangeList.reduce((carry, age) => {
        if (age < minAgeWithColor) {
            return {
                [age]: colors[0],
                ...carry,
            };
        }

        if (age > maxAgeWithColor) {
            return {
                [age]: colors[colors.length - 1],
                ...carry,
            };
        }

        return {
            [age]: colors[age - minAgeWithColor],
            ...carry,
        };
    }, {});

const maleColorsByAge = generateColorsMapByAgesRange(agesRangeList, baseMaleColors);
const femaleColorsByAge = generateColorsMapByAgesRange(agesRangeList, baseFemaleColors);
const nogenderColorsByAge = generateColorsMapByAgesRange(agesRangeList, baseNogenderColors);

const allGenderColorsList = [
    ...Object.values(maleColorsByAge),
    ...Object.values(femaleColorsByAge),
    ...Object.values(nogenderColorsByAge),
];

export {
    baseNogenderColors,
    maleColorsByAge,
    femaleColorsByAge,
    nogenderColorsByAge,
    allGenderColorsList,
};
